/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UrnTypeEnum = "Email" | "Integration" | "Org" | "Phone" | "User" | "%future added value";
export type EventSummaryAttendees_attendees = ReadonlyArray<{
    readonly displayName: string | null;
    readonly urnValue: string;
    readonly profileId: string | null;
    readonly urnType: UrnTypeEnum | null;
    readonly " $refType": "EventSummaryAttendees_attendees";
}>;
export type EventSummaryAttendees_attendees$data = EventSummaryAttendees_attendees;
export type EventSummaryAttendees_attendees$key = ReadonlyArray<{
    readonly " $data"?: EventSummaryAttendees_attendees$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryAttendees_attendees">;
}>;



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "EventSummaryAttendees_attendees",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urnValue",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urnType",
            "storageKey": null
        }
    ],
    "type": "Attendee",
    "abstractKey": null
} as any;
(node as any).hash = 'df04833ab6b73f2355f661182f16af9b';
export default node;
